export const beautifyText = (text: string): string => {
	return text.replace(/\n/g, "<br/>");
};
